import { render, staticRenderFns } from "./CourseCreateStudentList.vue?vue&type=template&id=46934149&scoped=true&"
import script from "./CourseCreateStudentList.vue?vue&type=script&lang=ts&"
export * from "./CourseCreateStudentList.vue?vue&type=script&lang=ts&"
import style0 from "./CourseCreateStudentList.vue?vue&type=style&index=0&id=46934149&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46934149",
  null
  
)

export default component.exports